import db from '../../services/DexieDatabase';

export default {
  getAll() {
    return db.destinations.toArray();
  },
};
